import React from 'react';
import Button, { ButtonVariantType } from '@dealroadshow/uikit/core/components/Button';
import cn from 'classnames';

import spacesStyles from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';
import styles from '@/Framework/UI/Organisms/Filters/FiltersPanel/FiltersBtn/filtersBtn.scss';

interface IProps {
  onClick: () => void,
}

const ActionsBtn = ({ onClick }:IProps) => {
  return (
    <Button
      variant={ ButtonVariantType.action }
      className={ cn(
        spacesStyles.mrn,
        styles.button,
      ) }
      dataTest="stratsActionsButton"
      onClick={ onClick }
    >
      <span>Actions</span>
    </Button>
  );
};

export default ActionsBtn;
